import React from 'react';
import styled from 'styled-components';
import {Play} from 'lucide-react';

const AboutSection = styled.section`
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 5rem 0;

  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 4rem 1.5rem;
  }
`;

const AboutGrid = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 3rem;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const AboutContent = styled.div`
  width: 52%;

  @media screen and (max-width: 768px) {
    width: 100%;
    order: 2;
  }
`;

const Eyebrow = styled.p`
  font-family: var(--font-body);
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--color-accent-hover);
  margin-bottom: 1rem;
`;

const AboutTitle = styled.h2`
  font-family: var(--font-display);
  font-size: clamp(1.9rem, 3vw, 2.6rem);
  font-weight: 700;
  color: var(--color-brand-deep);
  margin-bottom: 1.5rem;

  span {
    color: var(--color-accent);
  }
`;

const AboutText = styled.p`
  font-family: var(--font-body);
  font-size: 1.05rem;
  color: var(--color-ink-soft);
  line-height: 1.65;
  margin-bottom: 2.25rem;
`;

const AboutButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 2rem;
  background: var(--color-accent);
  border-radius: var(--radius-sm);
  font-family: var(--font-body);
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--color-white);
  text-decoration: none;
  transition: all 0.25s ease;
  gap: 10px;

  &:hover {
    background: var(--color-accent-hover);
    transform: translateY(-3px);
  }

  @media screen and (max-width: 768px){
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const AboutImage = styled.img`
  width: 420px;
  height: auto;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-strong);

  @media screen and (max-width: 768px) {
    width: 100%;
    order: 1;
  }
`;

const About = () => {
  return (
    <AboutSection id="about">
      <AboutGrid>
        <AboutContent>
          <Eyebrow>Nossa missão</Eyebrow>
          <AboutTitle>
            Facilitar a gestão de <span>bares e restaurantes</span>
          </AboutTitle>
          <AboutText>
            Simplificamos o seu dia a dia automatizando processos, melhorando o controle e oferecendo ferramentas que facilitam o atendimento do seu cliente e a gestão dos recursos do seu estabelecimento. Assim, permitimos que os proprietários e suas equipes se concentrem no que realmente importa: a arte de criar e servir pratos incríveis e gerar momentos inesquecíveis para seus clientes.
          </AboutText>
          <AboutButton href='https://app.sofchef.com.br' target='_blank' data-cta-id="about-teste-gratis">
            <Play size={20} color={'#fff'}/>
            Faça um teste grátis
          </AboutButton>
        </AboutContent>

        <AboutImage src="/images/restaurant-2.png" alt="Salão de restaurante gerenciado com o SofChef" />
      </AboutGrid>
    </AboutSection>
  );
};

export default About;
